<template>
  <b-card
    no-body
    class=" border border-2 h-100"
  >
    <div class="flex justify-between items-start px-1 pt-1">
      <div>
        <div class="font-bold text-[16px] text-black">
          Distribusi Token
        </div>
        <div class="text-[#A0A0A0] text-[12px]">
          Rasio Input vs Output
        </div>
      </div>
      <MonthFilter
        :month.sync="month"
      />
    </div>

    <div class="flex gap-2 mb-4 px-1 mt-1">
      <div class="border rounded p-1 flex-1">
        <div class="text-[#A0A0A0] text-[12px] flex items-center gap-2 mb-1">
          <div class="w-3 h-3 rounded-full bg-[#F97316]" /> Input
        </div>
        <div class="font-semibold text-[18px]">
          {{ formatShortNumber(inputToken) }}
        </div>
      </div>
      <div class="border rounded p-1 flex-1">
        <div class="text-[#A0A0A0] text-[12px] flex items-center gap-2 mb-1">
          <div class="w-3 h-3 rounded-full bg-[#FDBA74]" /> Output
        </div>
        <div class="font-semibold text-[18px]">
          {{ formatShortNumber(outputToken) }}
        </div>
      </div>
    </div>

    <div class="px-1 mt-4 flex justify-center items-center h-[200px] relative">
      <vue-apex-charts
        type="donut"
        width="350"
        :options="chartOptions"
        :series="series"
      />
      <div class="absolute flex flex-col items-center justify-center pointer-events-none">
        <div class="font-semibold text-xl leading-tight text-black">
          {{ formatShortNumber(totalToken) }}
        </div>
        <div class="text-[12px] text-[#A0A0A0]">
          Total Token
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import { START_DATE_OF_MONTH, END_DATE_OF_MONTH } from '@/libs/filterDate'
import MonthFilter from './MonthFilter.vue'
import { formatShortNumber } from '../config'
import { apiDataDistributeToken } from '../services/api.komchat.service'

export default {
  name: 'TokenDistributionChart',
  components: {
    'vue-apex-charts': VueApexCharts,
    MonthFilter,
  },
  data() {
    return {
      moment,
      month: moment(),
      inputToken: 0,
      outputToken: 0,
      totalToken: 0,
      series: [0, 0],
      chartOptions: {
        chart: { type: 'donut' },
        labels: ['Input', 'Output'],
        colors: ['#F97316', '#FDBA74'],
        dataLabels: { enabled: false },
        plotOptions: {
          pie: {
            donut: {
              size: '75%',
              labels: { show: false },
            },
          },
        },
        legend: { show: false },
        stroke: { width: 0 },
        tooltip: {
          enabled: true,
        },
      },
    }
  },
  watch: {
    month() {
      this.fetchData()
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    formatShortNumber,
    async fetchData() {
      const startDate = START_DATE_OF_MONTH(this.month)
      const endDate = END_DATE_OF_MONTH(this.month)

      try {
        const res = await apiDataDistributeToken({ startDate, endDate })
        if (res && res.data && res.data.data) {
          const { input, output } = res.data.data
          this.inputToken = input || 0
          this.outputToken = output || 0
          this.totalToken = this.inputToken + this.outputToken

          this.series = [this.inputToken, this.outputToken]
        } else {
          this.inputToken = 0
          this.outputToken = 0
          this.totalToken = 0
          this.series = [0, 0]
        }
      } catch (err) {
        console.error('Failed to fetch token distribution', err)
      }
    },
  },
}
</script>
